<template>
  <div id="patient-detail" ref="patientDetail">
    <div class="alipay-top" v-if="deviceType == 'alipay'">
      <img src="../../assets/image/safe@2x.png" />
      <div>用户信息将严格对外保密</div>
    </div>
    <div class="input-form">
      <div class="form-item">
        <div class="cover">
          <div class="form-item-label">真实姓名</div>
          <div class="form-item-input">
            <input v-model="pramas.name" :disabled="isEditPatient === 0 || userInfo.clientID === isRuiZe" type="text"
              placeholder="信息保密，请放心填写" maxlength="10" @blur="verification('name')" />
          </div>
        </div>
      </div>
      <div class="form-item">
        <div class="cover">
          <div class="form-item-label">证件类型</div>
          <div class="form-item-input form-item-disabled">
            <div class="align-right">{{ cardTypeText }}</div>
          </div>
        </div>
      </div>
      <div class="form-item">
        <div class="cover">
          <div class="form-item-label">证件号码</div>
          <div class="form-item-input">
            <input v-model="pramas.id" type="text" :readonly="isEditPatient === 0 || userInfo.clientID === isRuiZe"
              placeholder="信息保密，请放心填写" maxlength="18" @blur="verification('id')" />
          </div>
        </div>
      </div>
      <!-- 非身份证类型：展示性别和出生日期 -->
      <template v-if="isNonIdCard">
        <div class="form-item">
          <div class="cover">
            <div class="form-item-label">性别</div>
            <div class="form-item-input">
              <van-radio-group v-model="pramas.sex" direction="horizontal">
                <van-radio icon-size="25" :name="1">男</van-radio>
                <van-radio icon-size="25" :name="2">女</van-radio>
              </van-radio-group>
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="cover">
            <div class="form-item-label">出生日期</div>
            <div class="form-item-input" @click="showBirthdayPicker">
              <div class="align-right" :class="{ 'placeholder-text': !pramas.birthday }">
                {{ pramas.birthday || '请选择出生日期' }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 瑞泽渠道 + 身份证类型：保留原有年龄字段 -->
      <template v-if="userInfo.clientID === isRuiZe && !isNonIdCard">
        <div class="form-item">
          <div class="cover">
            <div class="form-item-label">性别</div>
            <div class="form-item-input">
              <div style="color:#999" class="align-right">
                {{(sexList.find(item => item.value == pramas.sex)) && (sexList.find(item => item.value ==
                  pramas.sex)).text}}
              </div>
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="cover">
            <div class="form-item-label">年龄</div>
            <div class="form-item-input">
              <input v-model="pramas.age" type="tel" maxlength="3" readonly style="color:#999" />
            </div>
            <span style="color:#999" class="age-unit">
              {{(ageUnitList.find(item => item.value == pramas.ageUnit)) && (ageUnitList.find(item => item.value ==
                pramas.ageUnit)).text}}
            </span>
          </div>
        </div>
      </template>
      <div class="form-item">
        <div class="cover">
          <div class="form-item-label">手机号码</div>
          <div class="form-item-input">
            <input v-model="pramas.phone" type="text" :disabled="isEditPatient === 0" placeholder="信息保密，请放心填写"
              maxlength="11" @blur="verificationPhone" />
          </div>
        </div>
      </div>
      <div class="form-item" v-show="!isHaoYaoShiClient && pramas.age && (pramas.age <= 6 || pramas.ageUnit === 2)">
        <div class="cover">
          <div class="form-item-label">体重</div>
          <div class="form-item-input weight">
            <input v-model="pramas.patientWeight" type="number" placeholder="6岁及6岁以下儿童请填写体重" @blur="verificationWeight"
              maxlength="18" />Kg
          </div>
        </div>
      </div>
      <div class="form-item">
        <div class="cover">
          <div class="form-item-label">疾病史</div>
          <div class="form-item-input">
            <van-radio-group v-model="pramas.radio" direction="horizontal">
              <van-radio icon-size="25" name="yes" @click="diseaseChangeRadio('yes')"
                :class="deviceType == 'alipay' ? 'huafu-radio' : ''">有</van-radio>
              <van-radio icon-size="25" name="no" @click="diseaseChangeRadio('no')"
                :class="deviceType == 'alipay' ? 'huafu-radio' : ''">无</van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>
    </div>
    <div class="confirm">
      <div class="title">选择已确诊的疾病</div>
      <div class="confirm-select">
        <div :class="[
          index === confirmDisIndex
            ? deviceType == 'alipay'
              ? 'checked select-item huafu-btn'
              : 'checked select-item'
            : 'select-item',
        ]" v-for="(item, index) in confirmedDiseaseList" :key="item.id">
          <span @click="selectConfirmDisease(index, item.name)">{{ item.name }}</span>
        </div>
        <!--            <div class="addBtn">新增</div>-->
      </div>
      <div class="tip">
        <div class="dividing-line">
          <div class="content">就该病情是否已到线下医院就诊</div>
          <van-radio-group v-model="selectParams.radio" direction="horizontal">
            <van-radio icon-size="25" name="no" @click="visitChangeRadio('no')"
              :class="deviceType == 'alipay' ? 'huafu-radio' : ''">否</van-radio>
            <van-radio icon-size="25" name="yes" @click="visitChangeRadio('yes')"
              :class="deviceType == 'alipay' ? 'huafu-radio' : ''">是</van-radio>
          </van-radio-group>
        </div>
      </div>
    </div>
    <div class="voucher">
      <div class="title">复诊凭证 <span class="tips">（如处方/病历/检测报告等）</span></div>
      <div class="upload-group">
        <div v-for="(item, index) in uploadGroup" :key="'uploadGroup' + item.id" class="upload">
          <Upload accept="image/*" v-model:value="item.uploadValue" :disabled="disabled" @updateImage="updateImage"
            :identifier="item.id.toString()" @uploadFinsih="uploadFinsih"></Upload>
          <img src="../../assets/image/patient_delete_image.png" alt="" srcset="" v-show="item.uploadValue !== ''"
            @click="deleteImage(index, item)" />
        </div>
      </div>
    </div>
    <div class="button">
      <div class="sure">
        <van-checkbox icon-size="25" v-model="sure"
          :class="deviceType == 'alipay' ? 'huafu-radio' : 'checkbox'"></van-checkbox>
        <div class="sure-text">
          根据国家互联网诊疗相关规定，请仔细阅读<span class="detail" @click="risNotification = true">《互联网诊疗风险告知及知情同意书》</span>与
          <span class="detail" @click="sensitivePersonalInformation = true">《敏感个人信息处理规则》</span>
        </div>
      </div>
      <div class="btnDiv">
        <div class="button-button" @click="submit()"
          :class="!sure || !selectParams.radio || loading ? 'button-grey' : deviceType == 'alipay' ? 'huafu-btn' : ''">
          开始问诊
        </div>
      </div>

      <!-- <div class="button-button" @click="submit2()" :class="!sure || !selectParams.radio ? 'button-grey' : ''">TCTC检测</div> -->
    </div>
    <UpAction :show.sync="disease" :clickClose="false">
      <div class="up-action-container">
        <div class="up-action-title">
          疾病史
          <img src="../../assets/image/patient_close.png" alt="" srcset="" @click="close" />
        </div>
        <div class="container-content">
          <div class="up-action-item">
            <div class="up-action-item-radio fsize-16">
              <div class="label">过敏史</div>
              <van-radio-group v-model="diseaseHistory.allergy.value" direction="horizontal">
                <van-radio icon-size="25" name="yes" class="disease-radio"
                  :class="deviceType == 'alipay' ? 'huafu-radio' : ''">有</van-radio>
                <van-radio icon-size="25" name="no" class="disease-radio"
                  :class="deviceType == 'alipay' ? 'huafu-radio' : ''">无</van-radio>
              </van-radio-group>
            </div>
            <div class="disease-select" v-show="diseaseHistory.allergy.value === 'yes'">
              <div :class="[
                item.checked
                  ? deviceType == 'alipay'
                    ? 'checked select-item huafu-btn'
                    : 'checked select-item'
                  : 'select-item',
              ]" v-for="(item, index) in diseaseHistoryList" :key="'diseaseHistoryList' + index"
                @click="selectAllergy(item)">
                {{ item.name }}
              </div>
            </div>
            <div class="disease-textarea fsize-14" v-show="diseaseHistory.allergy.value === 'yes'">
              <textarea rows="2" v-model="diseaseHistory.allergy.supplement" placeholder="请补充过敏史"
                maxlength="10"></textarea>
            </div>
          </div>
          <div class="up-action-item">
            <div class="up-action-item-radio fsize-16">
              <div class="label">过往病史</div>
              <van-radio-group v-model="diseaseHistory.historyMedical.value" direction="horizontal">
                <van-radio name="yes" icon-size="25" class="disease-radio"
                  :class="deviceType == 'alipay' ? 'huafu-radio' : ''">有</van-radio>
                <van-radio name="no" icon-size="25" class="disease-radio"
                  :class="deviceType == 'alipay' ? 'huafu-radio' : ''">无</van-radio>
              </van-radio-group>
            </div>
            <div class="disease-textarea fsize-14" v-show="diseaseHistory.historyMedical.value === 'yes'">
              <textarea rows="2" v-model="diseaseHistory.historyMedical.supplement" placeholder="请补充既往病史"
                maxlength="10"></textarea>
            </div>
          </div>
          <div class="up-action-item" v-show="pramas.sex !== 1">
            <div class="up-action-item-radio fsize-16">
              <div class="label">妊娠哺乳备孕</div>
              <van-radio-group v-model="diseaseHistory.pregnancy.value" direction="horizontal">
                <van-radio name="yes" icon-size="25" class="disease-radio"
                  :class="deviceType == 'alipay' ? 'huafu-radio' : ''">有</van-radio>
                <van-radio name="no" icon-size="25" class="disease-radio"
                  :class="deviceType == 'alipay' ? 'huafu-radio' : ''">无</van-radio>
              </van-radio-group>
            </div>
            <div class="disease-select" v-show="diseaseHistory.pregnancy.value === 'yes'">
              <div :class="[
                item.checked
                  ? deviceType == 'alipay'
                    ? 'checked select-item huafu-btn'
                    : 'checked select-item'
                  : 'select-item',
              ]" v-for="(item, index) in pregnancyList" :key="'pregnancyList' + index" @click="pregnancyClick(item)">
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="up-action-item">
            <div class="up-action-item-radio fsize-16">
              <div class="label">肝功能</div>
              <van-radio-group v-model="diseaseHistory.liver" direction="horizontal">
                <van-radio name="yes" icon-size="25" class="disease-radio"
                  :class="deviceType == 'alipay' ? 'huafu-radio' : ''">异常</van-radio>
                <van-radio name="no" icon-size="25" class="disease-radio"
                  :class="deviceType == 'alipay' ? 'huafu-radio' : ''">正常</van-radio>
              </van-radio-group>
            </div>
          </div>
          <div class="up-action-item border-none">
            <div class="up-action-item-radio fsize-16">
              <div class="label">肾功能</div>
              <van-radio-group v-model="diseaseHistory.renal" direction="horizontal">
                <van-radio name="yes" icon-size="25" class="disease-radio"
                  :class="deviceType == 'alipay' ? 'huafu-radio' : ''">异常</van-radio>
                <van-radio name="no" icon-size="25" class="disease-radio"
                  :class="deviceType == 'alipay' ? 'huafu-radio' : ''">正常</van-radio>
              </van-radio-group>
            </div>
          </div>
          <div class="seat"></div>
        </div>
        <div class="btnDiv">
          <div :class="deviceType == 'alipay' ? 'button-button margin-top-8 huafu-btn' : 'button-button margin-top-8'"
            @click="close">
            确认
          </div>
        </div>
      </div>
    </UpAction>
    <UpAction :show.sync="risNotification" :clickClose="false">
      <div class="up-action-container">
        <div class="up-action-title">
          互联网诊疗风险告知及知情同意书
          <img src="../../assets/image/patient_close.png" alt="" srcset="" @click="risNotification = false" />
        </div>
        <div class="container-content font-size-14">
          <p :class="item.class" v-for="(item, index) in riskStatement" :key="index">{{ item.text }}</p>
          <div class="seat"></div>
        </div>
        <div class="btnDiv">
          <div :class="deviceType == 'alipay' ? 'button-button margin-top-8 huafu-btn' : 'button-button margin-top-8'"
            @click="risNotification = false">
            我已阅读并知晓
          </div>
        </div>
      </div>
    </UpAction>
    <UpAction :show.sync="sensitivePersonalInformation" :clickClose="false">
      <div class="up-action-container">
        <div class="up-action-title">
          敏感个人信息处理规则
          <img src="../../assets/image/patient_close.png" alt="" srcset=""
            @click="sensitivePersonalInformation = false" />
        </div>
        <div class="container-content font-size-14">
          <p :class="item.class" v-for="(item, index) in sensitivePersonalInformationStatement" :key="index">{{
            item.text }}
          </p>
          <div class="seat"></div>
        </div>
        <div class="btnDiv">
          <div :class="deviceType == 'alipay' ? 'button-button margin-top-8 huafu-btn' : 'button-button margin-top-8'"
            @click="sensitivePersonalInformation = false">
            我已阅读并知晓
          </div>
        </div>
      </div>
    </UpAction>
    <UpAction :show.sync="addDialog">
      <div class="add-dialog">
        <div class="add-dialog-title">请输入确诊疾病</div>
        <div class="add-dialog-textarea">
          <textarea rows="3" v-model="addDisease" placeholder="请输入线下确认的疾病" maxlength="10"></textarea>
        </div>
        <div class="add-dialog-button" @click="diseaseAdd">确定</div>
      </div>
    </UpAction>
    <div v-show="backTag" class="shelter-view">
      <img src="../../assets/image/img_quit.png" />
      <div class="shelter-span">
        <span>是否继续问诊？</span>
      </div>
      <div class="shelter-button" @click="handelContinue">继续问诊</div>
    </div>
    <!-- pop -->
    <van-popup v-model="showPop" :close-on-click-overlay="false"> 服务时间为 X:00 - X:00, 请在服务时间段内发起问诊 </van-popup>
    <!-- 性别选择 -->
    <van-popup safe-area-inset-bottom v-model:show="showPicker" round position="bottom">
      <van-picker title="性别" show-toolbar :columns="sexList" @confirm="onConfirmSex" @cancel="showPicker = false" />
    </van-popup>
    <!-- 年龄单位选择 -->
    <van-popup safe-area-inset-bottom v-model:show="ageShowPicker" round position="bottom">
      <van-picker title="单位" show-toolbar :columns="ageUnitList" @confirm="onConfirmAgeUnit"
        @cancel="ageShowPicker = false" />
    </van-popup>
    <!-- 出生日期选择 -->
    <van-popup safe-area-inset-bottom v-model:show="showBirthdayPopup" round position="bottom">
      <van-date-picker v-model="birthdayPickerValue" title="选择出生日期" :min-date="minBirthdayDate"
        :max-date="maxBirthdayDate" @confirm="onConfirmBirthday" @cancel="showBirthdayPopup = false" />
    </van-popup>
  </div>
</template>
<script>
import { showNotify, showDialog } from 'vant';
import Upload from '../../components/upload.vue'
import UpAction from '../../components/upAction.vue'
import { mapMutations, mapGetters } from 'vuex'
import { checkCamera } from '../../utils/checkCamera'
import selectImage from '../../assets/image/patient_more.png'
// 公共方法
import { riskStatement, getUrlParams, calculateAgeAndMonths, sensitivePersonalInformationStatement } from '../../utils/const'
// 组件相关校验方法
import { diseaseHistoryChecked, checkDisease } from './modules/dataProcess'

export default {
  name: '',
  components: {
    Upload,
    UpAction
  },
  data() {
    return {
      //   deviceType: '',
      selectImage,
      weightErr: false,
      patientInfoData: '', // 身份证认证获取患者信息
      certificateList: [], // 复诊凭证图
      hisCertificateList: [], // 问诊带过来的复诊图
      showPop: false,
      inquiryMode: 0, // 订单类型（非好药师渠道使用）
      bizType: -1, // 业务类型：0=快速问诊，2=复诊开方（好药师渠道使用）
      isReviewInquiry: 0, // 是否复诊：1=复诊
      diseaseHistoryList: [
        { name: '青霉素' },
        { name: '阿司匹林' },
        { name: '螨尘' },
        { name: '花粉' },
        { name: '海鲜' },
        { name: '蛋白质（牛奶鸡蛋）' }
      ],
      confirmedDiseaseList: [
        { name: '感冒' },
        { name: '咽炎' },
        { name: '扁桃体炎' },
        { name: '支气管炎' },
        { name: '哮喘' },
        { name: '鼻炎' },
        { name: '牙龈炎' },
        { name: '中耳炎' },
        { name: '消化不良' },
        { name: '腹泻' },
        { name: '痤疮' },
        { name: '湿疹' },
        { name: '尿道炎' },
        { name: '便秘' },
        { name: '结膜炎' },
        { name: '阴道炎' },
        { name: '月经不调' },
        { name: '骨质疏松' },
        { name: '高血压' },
        { name: '低血压' },
        { name: '糖尿病' },
        { name: '痛风' },
        { name: '其他' }
      ],
      showPicker: false,
      idCardMsg: false,
      cardColumns: [{
        value: 0,
        text: '居民身份证'
      }, {
        value: 1,
        text: '护照'
      }, {
        value: 2,
        text: '港澳居民来往内地通行证'
      },
      {
        value: 3,
        text: '台湾居民来往大陆通行证'
      },
      {
        value: 4,
        text: '其他'
      },
      {
        value: 99,
        text: '其他'
      }],
      confirmDisIndex: '',
      confirmDisVal: '',
      addDisease: '',
      addDialog: false,
      sensitivePersonalInformation: false,
      diseaseHistory: {
        allergy: {
          value: 'no',
          supplement: '',
          selectList: ''
        },
        historyMedical: {
          value: 'no',
          supplement: ''
        },
        pregnancy: {
          value: 'no',
          selectList: ''
        },
        liver: 'no',
        renal: 'no'
      },
      have: 0,
      uploadGroup: [{ uploadValue: '', id: 1, file: null, keyID: '', isDelete: 0 }],
      disabled: false,
      pramas: {
        radio: 'no',
        name: '',
        phone: '',
        id: '',
        sex: '',
        age: '',
        cardType: '',
        patientWeight: '',
        ageUnit: 1,
        birthday: '' // 出生日期，非身份证类型时使用
      },
      selectParams: {
        radio: ''
      },
      more: false,
      radio: true,
      sureRadio: false,
      sure: false,
      disease: false,
      selectList: [],
      pregnancyList: [
        { name: '妊娠', id: 2 },
        { name: '哺乳', id: 3 },
        { name: '备孕', id: 1 }
      ],
      patientInfo: {
        sex: '',
        age: ''
      },
      sexList: [
        { text: '男', value: 1 },
        { text: '女', value: 2 }
      ],
      ageShowPicker: false,
      ageUnitList: [
        { text: '岁', value: 1 },
        { text: '个月', value: 2 }
      ],
      verificationResult: true,
      verificationUniqueID: 0,
      risNotification: false,
      params: {},
      backTag: false,
      idCardErr: false, // 身份证是否有误
      imgList: [],
      isEditPatient: 1,
      loading: false, // 避免重复提交
      token: '',
      isRuiZe: process.env.VUE_APP_RUIZE_CLIENT_ID, // 是否是睿择
      isHaoYaoShiList: [
        process.env.VUE_APP_HAOYAOSHI_CLIENT_ID,
        process.env.VUE_APP_HAOYAOSHI_CLIENT_ID_2,
        process.env.VUE_APP_HAOYAOSHI_CLIENT_ID_3,
        process.env.VUE_APP_GUDIANWENNUAN_CLIENT_ID
      ].filter(Boolean), // 好药师 clientID 列表
      showBirthdayPopup: false, // 出生日期选择器
      birthdayPickerValue: ['1980', '01', '01'],
      minBirthdayDate: new Date(1900, 0, 1),
      maxBirthdayDate: new Date()
    }
  },
  computed: {
    age: function () {
      if (!this.patientInfo.age) return 0
      return parseInt(this.patientInfo.age.split('岁')[0]) || 0
    },
    // 是否好药师渠道
    isHaoYaoShiClient: function () {
      return this.isHaoYaoShiList.includes(this.userInfo.clientID)
    },
    // 证件类型展示文案（兼容旧数据）
    cardTypeText: function () {
      const found = this.cardColumns.find(item => item.value === this.pramas.cardType)
      if (found) return found.text
      // 兼容旧的1-4枚举值，统一展示为"其他"
      if (this.pramas.cardType !== 0 && this.pramas.cardType !== '') return '其他'
      return ''
    },
    // 是否为非身份证类型
    isNonIdCard: function () {
      return this.pramas.cardType !== 0 && this.pramas.cardType !== ''
    },
    riskStatement: () => riskStatement,
    sensitivePersonalInformationStatement: () => sensitivePersonalInformationStatement,
    ...mapGetters(['userInfo', 'orderDetail', 'urlParams', 'deviceType', 'endInquiry', 'huafuUI'])
  },
  created() {
    this.token = this.$route.query.token
    this.getSdkAppId()
  },
  mounted() {
    this.getUrlParams()
    this.cacheMapper()
    this.$bus.on('naviBack', () => {
      this.backTag = true
    })
    const { deviceType, bizID, clientID, timestamp, sign } = this.$route.query
    if (deviceType == 'alipay') {
      this.isEditPatient = 0
    }
    //   this.deviceType = deviceType

    const endInquiry = {
      bizID,
      clientID,
      timestamp,
      sign,
      deviceType
    }

    this['global/updateEndInquiry'](endInquiry)
    this['global/updateDeviceType'](deviceType)
    this.$bus.on('updateSuccess', (item) => {
      let find = false
      for (let i = 0; i < this.imgList.length; i++) {
        if (this.imgList[i].id === item.id) {
          this.imgList[i].flag = true
          find = true
          break
        }
      }
      if (!find) {
        this.imgList.push(item)
      }
    })
  },
  beforeUnmount() {
    // Make sure to remove the event listener when component is unmounted
    this.$bus.off('naviBack')
  },
  methods: {
    getSdkAppId() {
      const params = {
        token: this.token
      }
      this.$_http.get(this.$_API.H5_INQUIRY_GET_SDKAPPID, { params }).then((res) => {
        const { appID } = res.data
        window.sessionStorage.setItem('appID', appID)
      })
    },
    getParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return decodeURIComponent(r[2])
      }
      return null
    },
    handelContinue() {
      this.$router.replace({
        path: '/consultation',
        query: {
          ...this.urlParams
        }
      })
    },
    // 上次订单还在等待
    wating() {
      if (this.userInfo.orderStatus === 0) {
        this['global/updateMask'](true)
        this['global/updateStep'](1)
        this.$router.replace({
          path: '/consultation',
          query: {
            ...this.urlParams
          }
        })
      }
    },
    // 性别选择
    showPickerClick() {
      if (this.pramas.cardType === 0) return
      // 非身份证类型：性别始终可编辑（无法从证件号解析）
      // 身份证类型且不可编辑时，仅当性别为空才允许选择
      if (!this.isNonIdCard && this.isEditPatient === 0 && this.pramas.sex) return
      this.showPicker = true
    },
    onConfirmSex(currentValue) {
      this.pramas.sex = currentValue.value
      this.showPicker = false
    },
    // 出生日期选择
    showBirthdayPicker() {
      if (this.pramas.cardType === 0) return
      // 非身份证类型：出生日期始终可编辑（无法从证件号解析）
      // 身份证类型且不可编辑时，仅当出生日期为空才允许选择
      if (!this.isNonIdCard && this.isEditPatient === 0 && this.pramas.birthday) return
      // 如果已有出生日期，设置初始值
      if (this.pramas.birthday) {
        const parts = this.pramas.birthday.split('-')
        this.birthdayPickerValue = parts
      }
      this.showBirthdayPopup = true
    },
    onConfirmBirthday({ selectedValues }) {
      const [year, month, day] = selectedValues
      this.pramas.birthday = `${year}-${month}-${day}`
      this.showBirthdayPopup = false
      this.calculateAgeFromBirthday()
    },
    // 根据出生日期计算年龄
    calculateAgeFromBirthday() {
      if (!this.pramas.birthday) return
      const parts = this.pramas.birthday.split('-')
      const birthYear = parseInt(parts[0], 10)
      const birthMonth = parseInt(parts[1], 10)
      const birthDay = parseInt(parts[2], 10)
      const today = new Date()
      const currentYear = today.getFullYear()
      const currentMonth = today.getMonth() + 1
      const currentDay = today.getDate()
      let yearDiff = currentYear - birthYear
      let monthDiff = currentMonth - birthMonth
      if (monthDiff < 0) {
        yearDiff--
        monthDiff += 12
      }
      if (currentDay < birthDay) {
        monthDiff--
        if (monthDiff < 0) {
          yearDiff--
          monthDiff += 12
        }
      }
      if (yearDiff === 0) {
        this.pramas.age = monthDiff
        this.pramas.ageUnit = 2
      } else {
        this.pramas.age = yearDiff
        this.pramas.ageUnit = 1
      }
      this.patientInfo.age = this.pramas.age + '岁'
    },
    handleClickAgeUnit() {
      if (this.pramas.cardType === 0) return
      this.ageShowPicker = true
    },
    onConfirmAgeUnit(currentValue) {
      this.pramas.ageUnit = currentValue.value
      this.ageShowPicker = false
    },
    // 身份证认证
    idCardVerification(personName, idNo, callback = () => { }) {
      let that = this
      let personInfo = {
        personName: personName,
        idNo: idNo
      }
      this.$_http
        .post(this.$_API.H5_INQUIRY_CENTER_ID_CARD_VERI, personInfo)
        .then((res) => {
          if (res.success) {
            this.patientInfoData = res.data
            this.pramas.sex = res.data.sex
            this.patientInfo.sex = res.data.sex === 1 ? '男' : '女'
            this.idCardErr = false
            callback()
            if (res.data.age <= 0) {
              this.pramas.age = calculateAgeAndMonths(idNo).monthsAge
              this.pramas.ageUnit = 2
              this.patientInfo.age = this.pramas.age + '个月'
            } else {
              this.pramas.age = res.data.age
              this.pramas.ageUnit = 1
              this.patientInfo.age = res.data.age + '岁'
            }
            console.log('身份证认证成功')
          } else {
            this.pramas.age = ''
            this.pramas.sex = ''
            this.patientInfo.age = ''
            this.patientInfo.sex = ''
            this.idCardErr = true
          }
        })
        .catch((err) => {
          that.idCardErr = true
          this.pramas.age = ''
          this.pramas.sex = ''
          this.patientInfo.age = ''
          this.patientInfo.sex = ''
          console.log('错误？', err, that.idCardErr)
        })
    },
    // 提交申请单
    commitOrder() {
      if (this.loading) return
      const historyOfSickness = this.diseaseHistory.historyMedical.value === 'yes' ? 1 : 0
      if (historyOfSickness === 1 && !this.diseaseHistory.historyMedical.supplement) {
        showNotify({
          type: 'warning',
          message: '请补充既往病史',
          duration: 1000
        })
        this.disease = true
        return false
      }
      const historyOfAllergy = this.diseaseHistory.allergy.value === 'yes' ? 1 : 0
      let allergyDetail = []
      for (let i of this.diseaseHistoryList) {
        if (i.checked) {
          allergyDetail.push(i.name)
        }
      }
      allergyDetail = allergyDetail.toString()
      if (allergyDetail) {
        allergyDetail = this.diseaseHistory.allergy.supplement
          ? allergyDetail + ',' + this.diseaseHistory.allergy.supplement
          : allergyDetail
      } else {
        allergyDetail = this.diseaseHistory.allergy.supplement
      }
      if (historyOfAllergy === 1 && !allergyDetail) {
        showNotify({
          type: 'warning',
          message: '请选择或补充过敏史',
          duration: 1000
        })
        return false
      }
      let params = {
        inquiryOrderID: this.params.inquiryOrderID,
        bizID: this.params.bizID,
        isReviewInquiry: this.selectParams.radio === 'yes' ? 1 : 0,
        clientAppID: this.params.clientAppID,
        clientID: this.params.clientID,
        inquiryType: this.params.inquiryType,
        providerID: this.params.providerID,
        providerName: this.params.providerName,
        remoteInquiryOrderID: this.params.remoteInquiryOrderID
      }
      const liver = this.diseaseHistory.liver === 'yes' ? 1 : 0
      const renal = this.diseaseHistory.renal === 'yes' ? 1 : 0
      let pregnancy = ''
      for (let i of this.pregnancyList) {
        if (i.checked) {
          pregnancy = i.id
        }
      }
      const keyID = this.params.patientInfo ? this.params.patientInfo.keyID : ''
      // const patientIdNoType = this.params.patientInfo ? this.params.patientInfo.patientIdNoType : ''
      pregnancy = pregnancy === '' ? 0 : pregnancy
      let ageParam = {}
      if (this.pramas.ageUnit === 2) {
        ageParam.patientMonthAge = this.pramas.age
      } else {
        ageParam.patientAge = this.pramas.age
      }
      params.patientInfo = {
        allergyDetail: allergyDetail,
        historyOfAllergy: historyOfAllergy,
        historyOfSickness: historyOfSickness,
        illDesc: this.confirmDisVal,
        keyID: keyID,
        liver: liver,
        orderID: this.params.inquiryOrderID,
        ...ageParam,
        patientIdNo: this.pramas.id,
        patientIdNoType: this.pramas.cardType,
        patientName: this.pramas.name,
        patientPhone: this.pramas.phone,
        patientSex: this.pramas.sex,
        patientWeight: this.pramas.patientWeight === 'undefined' ? 0.0 : this.pramas.patientWeight,
        pregnancy: pregnancy,
        renal: renal,
        sicknessDetail: this.diseaseHistory.historyMedical.supplement
      }
      // 非身份证类型：传入出生日期
      if (this.isNonIdCard && this.pramas.birthday) {
        params.patientInfo.patientBirthday = this.pramas.birthday
      }
      this.certificateList = []
      for (let i of this.uploadGroup) {
        if (i.uploadValue) {
          this.certificateList.push({ keyID: i.keyID, certificateUrl: i.uploadValue, isDelete: i.isDelete })
        }
      }
      params.certificateList = [...this.certificateList, ...this.hisCertificateList]
      this.loading = true
      this.$_http.post(this.$_API.H5_INQUIRY_CENTER_ORDER_COMMIT, params).then((res) => {
        this.loading = false
        if (res.success) {
          this['user/updateImInfo']({ ...res.data })
          this['global/updateStep'](1)
          this.$router.replace({
            path: '/waiting',
            query: {
              ...this.urlParams
            }
          })
        }
      }).catch((err) => {
        this.loading = false
        console.log('错误？', err)
      })
    },
    // 将cache信息映射
    cacheMapper() {
      this.params = this.userInfo
      delete this.params.orderStatus
      if (!this.userInfo.patientInfo) return
      // 先设置证件类型，后续逻辑依赖此值
      this.pramas.cardType = Number(this.userInfo.patientInfo.patientIdNoType)
      this.idCardMsg = this.pramas.cardType === 0
      if (this.pramas.cardType !== 0) {
        this.pramas.age = this.userInfo.patientInfo.patientAge
        // 好药师：patientSex 为 9（未知）时视为无数据
        const rawSex = this.userInfo.patientInfo.patientSex
        if (this.isHaoYaoShiList.includes(this.userInfo.clientID)) {
          this.pramas.sex = (rawSex === 9 || rawSex === '9') ? '' : rawSex
        } else {
          this.pramas.sex = rawSex
        }
        // 回显出生日期
        if (this.userInfo.patientInfo.patientBirthday) {
          this.pramas.birthday = this.userInfo.patientInfo.patientBirthday
          this.calculateAgeFromBirthday()
        }
      }
      this.pramas.ageUnit = 1
      this.pramas.name = this.userInfo.patientInfo.patientName || ''
      this.pramas.id = this.userInfo.patientInfo.patientIdNo || ''
      this.pramas.phone = this.userInfo.patientInfo.patientPhone || ''
      if (this.userInfo.patientInfo.patientPhone) {
        this.verificationPhone()
      }

      this.pramas.patientWeight = this.userInfo.patientInfo.patientWeight + ''
      // this.userInfo.indications.forEach(selectListItem => {
      //   this.selectList.push({ name: selectListItem })
      // })
      this.getAge()
      // 过敏史 checked
      this.diseaseHistoryList.forEach((item) => {
        item.checked = false
      })
      // 备孕 checked
      this.pregnancyList.forEach((item) => {
        item.checked = false
      })

      // 过敏史
      if (this.userInfo.patientInfo.historyOfAllergy === 1 || this.userInfo.patientInfo.historyOfAllergy === '1') {
        this.pramas.radio = 'yes'
        this.diseaseHistory.allergy.value = 'yes'
        let str = ''
        let first = true
        let arr = this.userInfo.patientInfo.allergyDetail.split(',')
        arr.forEach((item) => {
          let flag = false
          this.diseaseHistoryList.forEach((element) => {
            if (element.name === item) {
              flag = true
              element.checked = true
            }
          })
          if (!flag) {
            if (!first) {
              str += ','
            }
            str += item
          }
        })
        this.diseaseHistory.allergy.supplement = str
      }
      // 过往病史
      if (this.userInfo.patientInfo.historyOfSickness === 1 || this.userInfo.patientInfo.historyOfSickness === '1') {
        this.pramas.radio = 'yes'
        this.diseaseHistory.historyMedical.value = 'yes'
        this.diseaseHistory.historyMedical.supplement = this.userInfo.patientInfo.sicknessDetail
      }
      // 备孕
      switch (this.userInfo.patientInfo.pregnancy) {
        case 2:
          this.pregnancyList.forEach((item) => {
            if (item.name === '妊娠') {
              item.checked = true
            }
          })
          this.pramas.radio = 'yes'
          this.diseaseHistory.pregnancy.value = 'yes'
          break
        case '2':
          this.pregnancyList.forEach((item) => {
            if (item.name === '妊娠') {
              item.checked = true
            }
          })
          this.pramas.radio = 'yes'
          this.diseaseHistory.pregnancy.value = 'yes'
          break
        case 3:
          this.pregnancyList.forEach((item) => {
            if (item.name === '哺乳') {
              item.checked = true
            }
          })
          this.pramas.radio = 'yes'
          this.diseaseHistory.pregnancy.value = 'yes'
          break
        case '3':
          this.pregnancyList.forEach((item) => {
            if (item.name === '哺乳') {
              item.checked = true
            }
          })
          this.pramas.radio = 'yes'
          this.diseaseHistory.pregnancy.value = 'yes'
          break
        case 1:
          this.pregnancyList.forEach((item) => {
            if (item.name === '备孕') {
              item.checked = true
            }
          })
          this.pramas.radio = 'yes'
          this.diseaseHistory.pregnancy.value = 'yes'
          break
        case '1':
          this.pregnancyList.forEach((item) => {
            if (item.name === '备孕') {
              item.checked = true
            }
          })
          this.pramas.radio = 'yes'
          this.diseaseHistory.pregnancy.value = 'yes'
          break
        default:
          break
      }
      // 肝
      if (this.userInfo.patientInfo.liver === 1 || this.userInfo.patientInfo.liver === '1') {
        this.pramas.radio = 'yes'
        this.diseaseHistory.liver = 'yes'
      }
      // 肾功能
      if (this.userInfo.patientInfo.renal === 1 || this.userInfo.patientInfo.renal === '1') {
        this.pramas.radio = 'yes'
        this.diseaseHistory.renal = 'yes'
      }
      this.isEditPatient = this.userInfo.isEditPatient
      this.inquiryMode = this.userInfo.inquiryMode != null ? Number(this.userInfo.inquiryMode) : 0
      this.bizType = this.userInfo.bizType != null ? Number(this.userInfo.bizType) : -1
      this.isReviewInquiry = this.userInfo.isReviewInquiry != null ? Number(this.userInfo.isReviewInquiry) : 0
      if (this.userInfo.patientInfo && this.userInfo.patientInfo.illDesc) {
        const getIllDesc = this.userInfo.patientInfo.illDesc
        if (getIllDesc) {
          // 主诉
          this.confirmedDiseaseList.forEach((item, index) => {
            if (item.name === getIllDesc) {
              this.confirmDisIndex = index
              this.confirmDisVal = getIllDesc
            }
          })
        }
      }
      const getCertificateList = this.userInfo.certificateList
      if (getCertificateList && getCertificateList.length > 0) {
        for (let i of getCertificateList) {
          this.uploadGroup.unshift({
            uploadValue: i.certificateUrl,
            id: parseInt(Math.random() * 10000),
            file: null,
            keyID: i.keyID,
            isDelete: i.isDelete
          })
        }
      }
      if (this.userInfo.patientInfo) {
        if (this.userInfo.patientInfo.patientName && this.userInfo.patientInfo.patientIdNo && this.pramas.cardType === 0) {
          // 好药师不走实名认证
          if (!this.isHaoYaoShiList.includes(this.userInfo.clientID)) {
            this.idCardVerification(this.userInfo.patientInfo.patientName, this.userInfo.patientInfo.patientIdNo)
          }
        }
      }
      if (this.userInfo.inquiryType !== 1) {
        checkCamera(() => { })
      }
    },
    uploadFinsih(data) {
      const item = this.uploadGroup.find((item) => item.id == data.id)
      item.uploadValue = data.remoteAddress
      console.log(data)
    },
    // 获取当前时间减去身份证生日，得到年龄
    getAge() {
      if (!this.pramas.id) return false
      // 非身份证类型：从出生日期计算年龄
      if (this.pramas.cardType !== 0) {
        if (this.pramas.birthday) {
          this.calculateAgeFromBirthday()
        }
        return
      }
      // 身份证类型：从证件号解析
      let str =
        this.userInfo.patientInfo.patientIdNo.substr(6, 4) +
        '-' +
        this.userInfo.patientInfo.patientIdNo.substr(10, 2) +
        '-' +
        this.userInfo.patientInfo.patientIdNo.substr(12, 2)
      let time = new Date().getTime() - new Date(str).getTime()
      let age = parseInt(time / 1000 / 60 / 60 / 24 / 365)
      this.patientInfo.age = age + '岁'
      this.pramas.age = age
      this.pramas.ageUnit = 1

      let sexStr = this.userInfo.patientInfo.patientIdNo.substr(this.userInfo.patientInfo.patientIdNo.length - 2, 1)
      if (sexStr % 2 === 0) {
        this.patientInfo.sex = '女'
        this.pramas.sex = 2
      } else {
        this.patientInfo.sex = '男'
        this.pramas.sex = 1
      }
    },
    // 校验手机号
    verificationPhone() {
      // 好药师：只校验非空
      if (this.isHaoYaoShiList.includes(this.userInfo.clientID)) {
        if (!this.pramas.phone) {
          showNotify({
            type: 'warning',
            message: '请输入手机号码',
            duration: 1000
          })
          return false
        }
        return true
      }
      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(this.pramas.phone)) {
        showNotify({
          type: 'warning',
          message: '手机号码输入不正确',
          duration: 1000
        })
        return false
      }
      return true
    },
    // 把妊娠哺乳备孕做成单选
    pregnancyClick(item) {
      let pre = { ...item }
      this.pregnancyList.forEach((element) => {
        if (element.checked) {
          element.checked = false
        }
      })
      if (pre.checked) {
        item.checked = !pre.checked
      } else {
        item.checked = true
      }
      console.log(this.pregnancyList)
    },
    // 选择过敏史
    selectAllergy(item) {
      if (item.checked) {
        item.checked = !item.checked
      } else {
        item.checked = true
      }
    },
    // 体重校验
    verificationWeight() {
      if ((this.pramas.patientWeight < 1 || this.pramas.patientWeight > 100)) {
        showNotify({
          type: 'warning',
          message: '体重格式不正确',
          duration: 1000
        })
        this.weightErr = true
        return false
      }
      this.weightErr = false
    },
    // 这个是校验身份信息的接口
    // 实名认证
    verification(type) {
      if (this.pramas.cardType !== 0) return
      let _that = this
      // 校验身份证号
      function checkCard(value) {
        let reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        if (!reg.test(value)) {
          showNotify({
            type: 'warning',
            message: '身份证格式不正确',
            duration: 1000
          })
          _that.pramas.age = ''
          _that.pramas.sex = ''
          _that.idCardErr = true
          return false
        }
        _that.idCardErr = false
        // 本地从身份证解析性别
        let sexStr = value.substr(value.length - 2, 1)
        if (parseInt(sexStr) % 2 === 0) {
          _that.patientInfo.sex = '女'
          _that.pramas.sex = 2
        } else {
          _that.patientInfo.sex = '男'
          _that.pramas.sex = 1
        }
        // 本地从身份证解析年龄
        let ageResult = calculateAgeAndMonths(value)
        if (ageResult.monthsAge !== undefined) {
          _that.pramas.age = ageResult.monthsAge
          _that.pramas.ageUnit = 2
          _that.patientInfo.age = ageResult.monthsAge + '个月'
        } else {
          _that.pramas.age = ageResult.age
          _that.pramas.ageUnit = 1
          _that.patientInfo.age = ageResult.age + '岁'
        }
        // 好药师不走实名认证；非好药师且姓名已填写时走实名认证
        if (!_that.isHaoYaoShiList.includes(_that.userInfo.clientID) && _that.pramas.name) {
          _that.idCardVerification(_that.pramas.name, _that.pramas.id)
        }
        return true
      }
      // 校验名字
      function containsNumber(str) {
        var reg = /\d/
        if (reg.test(str)) {
          showNotify({
            type: 'warning',
            message: '姓名格式不正确',
            duration: 1000
          })
          return false
        }
        return true
      }
      if (type === 'id') {
        if (this.pramas.id === '') return false
        if (!checkCard(this.pramas.id)) {
          this.verificationUniqueID = 2
          return false
        }
      }
      if (type === 'name') {
        if (this.pramas.name === '') return false
        if (!containsNumber(this.pramas.name)) {
          this.verificationUniqueID = 2
          return false
        }
        // 姓名填写完成后，若身份证已填写，重新触发校验（可触发实名认证）
        if (this.pramas.id) {
          checkCard(this.pramas.id)
        }
      }
      this.verificationUniqueID = 1
    },
    // 删除上传的图片，凭证
    deleteImage(index, item) {
      if (item.keyID) {
        this.hisCertificateList.push({ keyID: item.keyID, certificateUrl: item.uploadValue, isDelete: 1 })
      }
      this.uploadGroup.splice(index, 1)
      if (this.uploadGroup[this.uploadGroup.length - 1].uploadValue !== '') {
        this.uploadGroup.push({ uploadValue: '', id: parseInt(Math.random() * 10000), file: null, keyID: '', isDelete: 0 })
      }
      console.log(this.uploadGroup)
    },
    // 选择已确诊疾病
    selectConfirmDisease(index, val) {
      this.confirmDisIndex = index
      this.confirmDisVal = val
    },
    // 删除已确诊疾病列表数据
    // 展示废弃
    deleteSelectList(single) {
      for (let [index, item] of this.selectList.entries()) {
        if (item.name === single.name) {
          this.selectList.splice(index, 1)
          return false
        }
      }
    },
    // 添加新的已确认疾病
    diseaseAdd() {
      if (this.addDisease === '') {
        showNotify({
          type: 'warning',
          message: '请输入确诊疾病',
          duration: 1000
        })
        return false
      }
      for (let [index, item] of this.selectList.entries()) {
        if (item.name === this.addDisease) {
          this.selectList.splice(index, 1)
          break
        }
      }
      this.selectList.unshift({ name: this.addDisease, checked: true })
      this.addDisease = ''
      this.addDialog = false
    },
    // 展示更多已确认疾病
    showMore() {
      this.more = !this.more
    },
    // 确认就该病情是否已到线下医院就诊
    visitChangeRadio(value) {
      if (value === 'yes') {
        this.radio = true
        this.selectParams.radio = 'yes'
      } else {
        this.radio = false
        this.selectParams.radio = 'no'
        showDialog({
          message: '根据国家互联网诊疗相关规定，若非复诊线上仅可提供咨询服务，不可开具处方。',
          confirmButtonText: '知道了',
          className: 'dialog-css',
          confirmButtonColor: 'var(--order-text, #438BEF)',
          closeOnClickOverlay: true
        })
      }
    },
    // 勾选疾病史radio
    diseaseChangeRadio(value) {
      if (value === 'yes') {
        this.disease = true
        this.pramas.radio = 'yes'
      } else {
        this.pramas.radio = 'no'
        this.diseaseHistory = this.$options.data().diseaseHistory
      }
    },
    // 上传图片成功回调
    updateImage({ files, id }) {
      let flag = false
      /* eslint-disable */
      this.uploadGroup.forEach((element) => {
        if (element.id == id) {
          element.file = files[0]
          if (element.uploadValue !== '') {
            flag = true
            return false
          }
        }
      })
      if (this.uploadGroup.length >= 4 || flag) {
        return false
      } else {
        this.uploadGroup.push({ uploadValue: '', id: parseInt(Math.random() * 10000), file: null, keyID: '', isDelete: 0 })
        console.log(this.uploadGroup)
      }
    },
    // 提交按钮，校验是否勾选同意《互联网诊疗风险告知书》
    submit() {
      if (this.loading) return
      let loading = false
      if (this.imgList) {
        this.imgList.map((item) => {
          if (!item.flag) {
            showDialog({
              message: '请等待复诊凭证上传成功再提交',
              confirmButtonText: '确定',
              className: 'dialog-css',
              confirmButtonColor: 'var(--order-text, #438BEF)',
              closeOnClickOverlay: true,
            })
            loading = true
          }
        })
      }
      if (loading) return
      if (!this.verificationPhone()) return
      if (!this.pramas.name) {
        showDialog({
          message: '请填写真实姓名',
          className: 'dialog-css',
          confirmButtonText: '确定',
          confirmButtonColor: 'var(--order-text, #438BEF)',
          closeOnClickOverlay: true,
        })
        return false
      }
      if (!this.pramas.id) {
        showDialog({
          message: '请填写证件号码',
          className: 'dialog-css',
          confirmButtonText: '确定',
          confirmButtonColor: 'var(--order-text, #438BEF)',
          closeOnClickOverlay: true,
        })
        return false
      }
      if (this.idCardErr && this.pramas.cardType === 0) {
        showDialog({
          message: '请填写正确的身份证号',
          confirmButtonText: '确定',
          className: 'dialog-css',
          confirmButtonColor: 'var(--order-text, #438BEF)',
          closeOnClickOverlay: true,
        })
        return false
      }
      if (this.isRuiZe === this.userInfo.clientID && !this.isNonIdCard) {
        if (!this.pramas.sex) {
          showDialog({
            message: '请填写性别',
            confirmButtonText: '确定',
            className: 'dialog-css',
            confirmButtonColor: 'var(--order-text, #438BEF)',
            closeOnClickOverlay: true,
          })
          return false
        }
        if (this.pramas.age === '') {
          showDialog({
            message: '请填写年龄',
            confirmButtonText: '确定',
            className: 'dialog-css',
            confirmButtonColor: 'var(--order-text, #438BEF)',
            closeOnClickOverlay: true,
          })
          return false
        }
        if ((this.pramas.age >= 12 || this.pramas.age <= 0) && this.pramas.ageUnit === 2) {
          showDialog({
            message: '请填写正确的年龄',
            confirmButtonText: '确定',
            className: 'dialog-css',
            confirmButtonColor: 'var(--order-text, #438BEF)',
            closeOnClickOverlay: true,
          })
          return false
        }
      }
      // 非身份证类型：校验性别和出生日期
      if (this.isNonIdCard) {
        if (!this.pramas.sex) {
          showDialog({
            message: '请选择性别',
            confirmButtonText: '确定',
            className: 'dialog-css',
            confirmButtonColor: 'var(--order-text, #438BEF)',
            closeOnClickOverlay: true,
          })
          return false
        }
        if (!this.pramas.birthday) {
          showDialog({
            message: '请选择出生日期',
            confirmButtonText: '确定',
            className: 'dialog-css',
            confirmButtonColor: 'var(--order-text, #438BEF)',
            closeOnClickOverlay: true,
          })
          return false
        }
      }
      if (this.patientInfoData.age <= 6 || this.pramas.ageUnit === 2) {
        this.verificationWeight()
        if (this.weightErr) {
          showDialog({
            message: '请填写正确的体重值',
            confirmButtonText: '确定',
            className: 'dialog-css',
            confirmButtonColor: 'var(--order-text, #438BEF)',
            closeOnClickOverlay: true,
          })
          return false
        }
      }
      if (!this.confirmDisVal) {
        showDialog({
          message: '请选择已确诊的疾病',
          confirmButtonText: '确定',
          className: 'dialog-css',
          confirmButtonColor: 'var(--order-text, #438BEF)',
          closeOnClickOverlay: true,
        })
        return false
      }
      if (!this.selectParams.radio) {
        showDialog({
          message: '请确认该病情是否已到线下医院就诊',
          confirmButtonText: '确定',
          className: 'dialog-css',
          confirmButtonColor: 'var(--order-text, #438BEF)',
          closeOnClickOverlay: true,
        })
        return false
      }
      if (!this.sure) {
        showDialog({
          message: '请勾选互联网诊疗风险告知及知情同意书',
          confirmButtonText: '确定',
          className: 'dialog-css',
          confirmButtonColor: 'var(--order-text, #438BEF)',
          closeOnClickOverlay: true,
        })
        return false
      }
      // 第二步：渠道分流
      // 非好药师渠道：触发实名认证，成功后提交
      if (this.pramas.cardType === 0 && !this.isHaoYaoShiList.includes(this.userInfo.clientID)) {
        this.idCardVerification(this.pramas.name, this.pramas.id, () => {
          this.commitOrder()
        })
      } else {
        // 好药师渠道：跳过实名认证，直接提交
        this.commitOrder()
      }
    },
    submit2() {
      location.href = 'https://web.sdk.qcloud.com/component/trtccalling/demo/web/latest/index.html#/login'
    },

    // 迭代数组方法（优化）
    foreachArray(arr, uniqueKey, callback) {
      let str = ''
      let first = true
      for (let key of arr.keys()) {
        let item = callback(arr[key])
        if (item || item === '') {
          if (first) {
            str += arr[key][uniqueKey]
            first = false
          } else {
            str += item === '' ? '' : '||' + arr[key][uniqueKey]
          }
        } else {
          showNotify({
            type: 'warning',
            message: '复诊凭证上传中..',
            duration: 1000,
          })
          this.verificationResult = false
          return false
        }
      }
      return str
    },
    // 关闭疾病史弹框
    close() {
      if (diseaseHistoryChecked.call(this)) {
        checkDisease.call(this)
      }
      this.disease = false
    },

    sunmarySelect(arr) {
      let str = ''
      let first = true
      for (let key of arr.keys()) {
        if (arr[key].checked) {
          if (first) {
            str += arr[key].name
            first = false
          } else {
            str += ',' + arr[key].name
          }
        }
      }
      return str
    },

    routerPush(data) {
      this['user/updateUserInfo']({
        orderStatus: data.orderStatus,
        ...this.params,
      })
      this.cacheMapper()
      if (!data.inquiryStatus) return
      if (data.inquiryStatus === 1) {
        this.$router.replace({
          path: '/waiting',
          query: {
            ...this.urlParams,
          },
        })
      } else if (data.inquiryStatus === 2 || data.inquiryStatus === 3 || data.inquiryStatus === 4) {
        if (data.inquiryType === 1) {
          this.$router.replace({
            path: '/consultation',
            query: {
              ...this.urlParams,
            },
          })
        }
        if (data.inquiryType === 2) {
          this.$router.replace({
            path: '/trtcCalling',
            query: {
              ...this.urlParams,
            },
          })
        }
        if (data.inquiryType === 3) {
          this.$router.replace({
            path: '/videoPage',
            query: {
              ...this.urlParams,
            },
          })
        }
      } else {
        showDialog({
          message: '订单已取消，请退出重试',
          confirmButtonText: '确定',
          className: 'dialog-css',
          confirmButtonColor: 'var(--order-text, #438BEF)',
          closeOnClickOverlay: true,
        })
      }
    },
    getCache() {
      if (this.backTag) return
      if (JSON.stringify(this.params) === '{}') return
      if (!this.params.orderID || !this.urlParams.token) return
      let params = this.params
      this.$_http.get(this.$_API.H5_INQUIRY_CENTER_GET_CACHE, { params }).then((res) => {
        if (res.data.orderStatus === 0 || res.data.orderStatus === 1) {
          this['user/updateOrderDetail']({
            orderID: res.data.inquiryOrderID,
            userSig: res.data.userSig,
            userID: res.data.userID,
            orderPatientID: res.data.orderPatientID,
            ...this.orderDetail,
          })
          this['global/updateStep'](1)
        }
        this['user/updateOrderDetail']({ orderID: res.data.inquiryOrderID, ...res.data, ...this.orderDetail })
        if (res.success) {
          // console.log(res.data)
          this.params = res.data
          const { isEditPatient } = res.data
          this.isEditPatient = isEditPatient
          this.inquiryMode = this.params.inquiryMode != null ? Number(this.params.inquiryMode) : 0
          this.bizType = this.params.bizType != null ? Number(this.params.bizType) : -1
          this.isReviewInquiry = this.params.isReviewInquiry != null ? Number(this.params.isReviewInquiry) : 0
          if (res.data.patientInfo && res.data.patientInfo.illDesc) {
            const getIllDesc = res.data.patientInfo.illDesc
            if (getIllDesc) {
              //主诉
              this.confirmedDiseaseList.forEach((item, index) => {
                if (item.name === getIllDesc) {
                  this.confirmDisIndex = index
                  this.confirmDisVal = getIllDesc
                }
              })
            }
          }
          const getCertificateList = res.data.certificateList
          if (getCertificateList && getCertificateList.length > 0) {
            for (let i of getCertificateList) {
              this.uploadGroup.unshift({
                uploadValue: i.certificateUrl,
                id: parseInt(Math.random() * 10000),
                file: null,
                keyID: i.keyID,
                isDelete: i.isDelete,
              })
            }
          }
          if (this.params.patientInfo) {
            if (this.params.patientInfo.patientName && this.params.patientInfo.patientIdNo) {
              // 好药师不走实名认证
              if (!this.isHaoYaoShiList.includes(this.userInfo.clientID)) {
                this.idCardVerification(this.params.patientInfo.patientName, this.params.patientInfo.patientIdNo)
              }
            }
          }
          this.routerPush(res.data)
          // 检测视频设备
          if (res.data.inquiryType !== 1) {
            checkCamera(() => { })
          }
        }
      })
    },
    getUrlParams() {
      if (this.$route.name === 'rpViewer') return
      let obj = this.$route.query
      if (!obj['orderID'] || !obj['token']) {
        showDialog({
          message: '参数缺失，请重新进入',
          confirmButtonText: '确定',
          className: 'dialog-css',
          confirmButtonColor: 'var(--order-text, #438BEF)',
          closeOnClickOverlay: true,
        })
      }
      this['global/updateUrlParams'](obj)
    },
    ...mapMutations([
      'global/updateMask',
      'global/updateStep',
      'global/updateUrlParams',
      'user/updateOrderDetail',
      'global/updateDeviceType',
      'global/updateEndInquiry',
      'user/updateUserInfo',
      'user/updateImInfo',
    ]),
  },
}
</script>
<style scoped lang="scss">
@import './patientDetail.scss';

// 不可编辑字段字体置灰，去掉浏览器默认灰色背景
.form-item-input>input:disabled,
.form-item-input>input[readonly] {
  color: #999;
  background-color: transparent;
  -webkit-text-fill-color: #999;
  opacity: 1;
}

.form-item-disabled {
  .align-right {
    color: #999;
  }
}

:deep(.van-popup) {
  padding: 24px 10px;
  border-radius: 8px;
  font-size: 14px;
  // width: 280px;
}

.fsize-16 {
  font-size: 16px;
}

.fsize-14 {
  font-size: 14px;
}

.alipay-top {
  width: 100vw;
  height: 32px;
  padding: 0 16px;
  background: var(--order-soft, #e5f8f5);
  display: flex;
  align-items: center;
  box-sizing: border-box;

  img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }

  div {
    color: var(--order-text, #57cfa5);
    font-size: 12px;
  }
}

.van-checkbox {
  width: 30px;
}

:deep(.huafu-radio) {
  .van-radio__icon--checked>.van-icon {
    background-color: var(--order-primary, #57cfa5) !important;
    border-color: var(--order-primary, #57cfa5) !important;
  }

  .van-checkbox__icon--checked>.van-icon {
    background-color: var(--order-primary, #57cfa5) !important;
    border-color: var(--order-primary, #57cfa5) !important;
  }
}

.align-right {
  text-align: right;
}

.placeholder-text {
  color: #c8c9cc;
}

.guardian-title-item {
  margin-top: 12px;

  .cover {
    border-bottom: none;
  }
}

@media (max-height: 610px) {
  .fsize-16 {
    font-size: 12px;
  }

  .fsize-14 {
    font-size: 10px;
  }
}
</style>
<style lang="scss">
@import './chaoneng.scss';
</style>
